var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSdkinline = function SvgSdkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M12.8 8.9c0 .2 0 .4.2.5l1.4 1.1-1.1 1.9-1.7-.7c-.2-.1-.4 0-.5.1-.5.4-1 .7-1.6.9-.2.1-.3.2-.3.4L9.1 15H6.9l-.2-1.8c0-.2-.1-.3-.3-.4-.6-.2-1.1-.5-1.6-.9-.1-.1-.4-.2-.5-.1l-1.7.7-1.1-1.9L3 9.4c.1-.1.2-.3.2-.5-.1-.6-.1-1.3 0-1.9 0-.2 0-.4-.2-.5l-1.4-1 1.1-1.9 1.7.7c.2.1.4 0 .5-.1.5-.4 1-.7 1.6-.9.1-.1.2-.3.2-.5L6.9 1H9l.2 1.8c0 .2.1.3.3.4.6.2 1.1.5 1.6.9.1.1.4.2.5.1l1.7-.7 1.1 1.9L13 6.6c-.1.1-.2.3-.2.5.1.3.1.6.1.9s0 .6-.1.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M6.299 10.494c.48.33 1.045.506 1.623.506.775 0 1.518-.316 2.066-.879A3.04 3.04 0 0 0 10.844 8c0-.593-.172-1.173-.493-1.667A2.94 2.94 0 0 0 9.04 5.228a2.85 2.85 0 0 0-1.688-.17 2.9 2.9 0 0 0-1.496.82c-.409.42-.687.955-.8 1.537a3.08 3.08 0 0 0 .166 1.733A3 3 0 0 0 6.3 10.494Z"
  })));
};
export default SvgSdkinline;